import React from "react";

const InstagramIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none">
    <path
      fill="url(#a)"
      d="M10 0C7.286 0 6.945.012 5.879.06 4.813.11 4.086.278 3.45.525A4.897 4.897 0 0 0 1.68 1.678 4.909 4.909 0 0 0 .525 3.45C.277 4.085.108 4.812.06 5.877.012 6.943 0 7.284 0 10s.012 3.056.06 4.122c.05 1.065.218 1.792.465 2.427a4.9 4.9 0 0 0 1.153 1.772 4.896 4.896 0 0 0 1.771 1.154c.636.247 1.363.416 2.428.465 1.066.048 1.407.06 4.123.06s3.056-.012 4.122-.06c1.065-.049 1.792-.218 2.429-.465a4.892 4.892 0 0 0 1.77-1.154 4.909 4.909 0 0 0 1.154-1.771c.246-.636.415-1.363.465-2.427.047-1.067.06-1.407.06-4.123s-.012-3.057-.06-4.123c-.05-1.065-.22-1.792-.465-2.427a4.908 4.908 0 0 0-1.154-1.772A4.887 4.887 0 0 0 16.55.525C15.912.278 15.185.109 14.12.06 13.055.012 12.716 0 9.999 0H10Zm-.896 1.802H10c2.67 0 2.986.01 4.04.058.976.044 1.505.207 1.857.344.467.181.8.398 1.15.748.35.35.566.683.748 1.15.137.352.3.881.344 1.856.048 1.054.059 1.371.059 4.04s-.01 2.985-.059 4.04c-.044.974-.207 1.504-.344 1.856a3.091 3.091 0 0 1-.748 1.149c-.35.35-.683.566-1.15.747-.352.138-.881.3-1.856.345-1.054.048-1.371.058-4.041.058-2.67 0-2.987-.01-4.04-.058-.976-.045-1.505-.208-1.858-.345a3.098 3.098 0 0 1-1.15-.748 3.1 3.1 0 0 1-.748-1.15c-.137-.351-.3-.88-.345-1.855-.047-1.055-.057-1.371-.057-4.042 0-2.67.01-2.985.057-4.04.045-.974.208-1.503.345-1.856.181-.467.398-.8.748-1.15.35-.35.683-.567 1.15-.748.353-.138.882-.3 1.857-.345.923-.042 1.28-.054 3.144-.056v.002Zm6.235 1.66a1.2 1.2 0 1 0 0 2.401 1.2 1.2 0 0 0 0-2.4ZM10 4.866a5.136 5.136 0 1 0 0 10.271 5.136 5.136 0 0 0 0-10.271Zm0 1.802a3.333 3.333 0 1 1 0 6.666 3.333 3.333 0 0 1 0-6.666Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={3.75}
        x2={14.375}
        y1={0}
        y2={20}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#405DE6" />
        <stop offset={0.151} stopColor="#5B51D8" />
        <stop offset={0.323} stopColor="#833AB4" />
        <stop offset={0.495} stopColor="#C13584" />
        <stop offset={0.646} stopColor="#E1306C" />
        <stop offset={0.802} stopColor="#F77737" />
        <stop offset={1} stopColor="#FFDC80" />
      </linearGradient>
    </defs>
  </svg>
);
export default InstagramIcon;
